import { createGlobalStyle } from "styled-components";
import "@milize/common/assets/less/antd.less";
import "./style.css";

export default createGlobalStyle``;
